export default __webpack_public_path__ + "alberta-status.0bd4604137c9ae52bf77.svg";